module.exports = __webpack_public_path__ + "img/nodeBackgroundDrawGridWhite.0efd751c.svg";